import * as React from 'react';
import { Stack, Typography, TextField, Grid } from '@mui/material';

import Service from '../../../util/Service';

// export default function NodeGateway(props) {
const NodeGateway = React.forwardRef((props, ref) => {    
    const { item, processo } = props;

    const [mapValor, setMapValor] = React.useState({});
    const childRef = React.useRef();

    React.useEffect(()=>{
        const i = processo.lstTask.find( t => t.idTask === item.id);
        setMapValor(i ? i.criterio:{} );

    }, [processo]);

    React.useImperativeHandle(ref, ()=> ({
        childMethod() {
            handleComplete();
          }
    }))

    const handleComplete = () => {
        const dado = {
            idTask: item.id,
            idProcesso: processo.id,
            // tipo: tipo,
            taskType: item.type,
            criterio: mapValor
        }
        
        Service.POST("/api/bpmn/salvarTaskDoProcesso", dado).then(resp => {
            console.log( resp );    
        }).catch(error => {
            console.error(error)
        })
    };
    function handleOnChange(e){
        var map = {...mapValor};
        map[e.target.id] = e.target.value;
        setMapValor( map );
    }
    function helperText(node){
        if(node){
            return "Proxima atividade: "+(node.businessObject.targetRef.name?node.businessObject.targetRef.name:'Proximo atividade');
        }
        return "Proximo atividade"
    }
    return (
        <div style={{ width:'100%'}}>
        <Grid container spacing={2} >
            <Grid size={12}>
                <Typography variant="h6" gutterBottom>
                    Defina critério para fluxo
                </Typography>
            </Grid>
            {/* <Gridsize={1}>
                <Button onClick={handleComplete}>
                    Salvar
                </Button>
            </Grid> */}
            <Grid size={12}>
                <Stack spacing={0}>
                    {item && item.outgoing.map((n, i) =>
                        <TextField key={i}
                            id={n.id}
                            label="Critério"                                
                            helperText={helperText(n)}
                            variant="standard"
                            value={mapValor[n.id]?mapValor[n.id]:''}
                            onChange={handleOnChange}
                            size='small'
                            />
                    )}                    
                </Stack>
            </Grid>            
        </Grid>
        </div>
    )
})

export default NodeGateway;